import * as React from "react"
import { SVGProps } from "react"

export const CampaignIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    fill="none"
    viewBox="0 0 48 48"
    {...props}
  >
    <path
      fill="currentColor"
      d="M42.019 25.134h-4.596q-.483 0-.809-.328a1.1 1.1 0 0 1-.325-.815q0-.487.325-.806a1.1 1.1 0 0 1 .809-.32h4.596q.484 0 .81.329.325.327.325.815t-.326.806a1.1 1.1 0 0 1-.81.32Zm-8.208 8.8q.304-.365.751-.445t.85.223l3.688 2.757q.384.304.465.751a1 1 0 0 1-.223.83 1.22 1.22 0 0 1-.76.466 1.01 1.01 0 0 1-.84-.224l-3.708-2.758a1.24 1.24 0 0 1-.446-.75q-.081-.447.223-.85m5.212-22.48-3.577 2.727q-.402.303-.85.223a1.2 1.2 0 0 1-.75-.466.97.97 0 0 1-.223-.82q.081-.457.446-.76l3.596-2.727q.383-.304.84-.223t.76.465a.97.97 0 0 1 .223.822 1.22 1.22 0 0 1-.465.759m-28.158 17.7H7.731q-1.18 0-2.033-.852-.852-.853-.852-2.033v-4.538q0-1.18.852-2.033.853-.852 2.033-.852h8.461L23 14.793q.711-.432 1.432-.013.722.417.722 1.255v15.93q0 .837-.722 1.256-.72.417-1.432-.013l-6.808-4.054h-3.058v6.673q0 .483-.328.809-.327.325-.815.325t-.807-.325a1.1 1.1 0 0 1-.319-.809zm12.02 1.334V17.512L16.8 21.116H7.73a.6.6 0 0 0-.423.192.6.6 0 0 0-.192.423v4.538a.6.6 0 0 0 .192.424.6.6 0 0 0 .424.191H16.8l6.084 3.604Zm5.038-.25V17.762q1.177 1.065 1.896 2.684.72 1.62.72 3.554c0 1.934-.24 2.474-.72 3.554q-.72 1.62-1.896 2.684"
    />
  </svg>
)
